import { createSelector } from '@ngrx/store';
import { virtualLocationsState } from '../root';

export const hasVirtualLocationsDownloaded = createSelector(virtualLocationsState, (virtualLocations) => virtualLocations.hasSucceeded);
